import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import { swal, typeChecker } from "../../../utils/methods";
import { _post } from "../../../utils/network";

import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb.component';
import FormField from "../../../components/Form/FormField/FormField.component";
import LoadingButton from '../../../components/LoadingButton/LoadingButton.component';

const TadbirContents = () => {
	const { t } = useTranslation();
	const { id } = useParams();
	const navigate = useNavigate();
	const location = useLocation();
	const formRef = useRef(null);
	const breadcrumbItems = [
		{ title: t('dashboard'), link: '/dashboard' },
		{ title: t('tadbir') }
	];
	const confirmSwal = statements => {
		swal(() => statements(), {
			text: t('are_you_sure_to_do_this'),
			confirmButtonText: t('yes'),
			cancelButtonText: t('no')
		});
	};

	const [updateButtonIsLoading, setUpdateButtonIsLoading] = useState(false);
	const updateTadbirContents = async (event) => {
		event.preventDefault();
		if(updateButtonIsLoading)
			return 0;
		let username = event.target.tadbirContentUsername.value.trim();
		if(!typeChecker(username, 'title'))
			return toast.warn(t('username') + ' ' + t('must_have_at_least_3_characters'));
		let password = event.target.tadbirContentPassword.value.trim();
		if(!typeChecker(password, 'title'))
			return toast.warn(t('password') + ' ' + t('must_have_at_least_3_characters'));
		let body = {
			content_id: tadbirContents.content_id,
			content_name: tadbirContents.content_name,
			content_information: {
				username,
				password
			}
		};
		confirmSwal(async () => {
			setUpdateButtonIsLoading(true);
			let response = await _post('/contents/admin/edit', body);
			setUpdateButtonIsLoading(false);
			switch(response.code){
				case 200:
					toast.success(response[t('api_message')]);
					break;
				default:
					toast.error(response[t('api_message')]);
			}
		});
	};

	const [tadbirContents, setTadbirContents] = useState({});
	const getTadbirContents = async () => {
		let body = {
			page: 1,
			count: 1,
			content_name: 'tadbir'
		};
		let response = await _post('/contents/admin/getAll', body);
		switch(response.code){
			case 200:
				setTadbirContents(response.data.contents[0]);
				break;
			default:
				toast.error(response[t('api_message')]);
		}
	};

	useEffect(() => {
		getTadbirContents();
	}, []);

	return (
		<>
			<Breadcrumb items={breadcrumbItems} />
			<div className="card mb-3">
				<div className="card-header">
					<h5 className="mb-0">{t('edit')} {t('tadbir_content')}</h5>
				</div>
				<div className="card-body bg-light">
					<form onSubmit={updateTadbirContents} ref={formRef}>
						<div className="row gx-2">
							<FormField fieldKey="tadbirContentUsername" title={t('username')} value={tadbirContents?.content_information?.username} required ltr />
							<FormField fieldKey="tadbirContentPassword" title={t('password')} value={tadbirContents?.content_information?.password} required ltr />
						</div>
						<div>
							<LoadingButton className="btn btn-primary d-inline-block mt-3 me-2" type="submit" name="edit" isLoading={updateButtonIsLoading}>
								<i className="fa fa-save"></i> {t('update')}
							</LoadingButton>
						</div>
					</form>
				</div>
			</div>
		</>
	);
};

export default TadbirContents;
